import { render, staticRenderFns } from "./FieldMol.vue?vue&type=template&id=85a68d84&scoped=true"
import script from "./FieldMol.vue?vue&type=script&lang=js"
export * from "./FieldMol.vue?vue&type=script&lang=js"
import style0 from "./FieldMol.vue?vue&type=style&index=0&id=85a68d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a68d84",
  null
  
)

export default component.exports